import { Directive, HostListener, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

const DEFAULT_COPY_MESSAGE = 'Número copiado al portapapeles';

@Directive({
  selector: '[appCopyToClipboard]'
})
export class CopyToClipboardDirective {
  @Input('appCopyToClipboard') textToCopy: string = '';
  @Input() copySuccessMessage: string = DEFAULT_COPY_MESSAGE;

  constructor(private toastr: ToastrService) {}

  @HostListener('click', ['$event'])
  onClick() {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData?.setData('text/plain', this.textToCopy);
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
    this.toastr.success(this.copySuccessMessage, 'Copiado');
  }
}
